import { trans } from '@/i18n';

export const msgMinLength = (min: number, name?: string) => {
  return trans('shared.minLengthValidate', { min, name: name ?? '' });
};

export const msgMaxLength = (max: number, name?: string) => {
  return trans('shared.maxLengthValidate', { max , name: name ?? '' });
};

export const msgRequired = (key: string) => {
  return trans('shared.required', { key: trans(key) });
};

export const msgInvalid = (key: string) => {
  return trans('shared.invalid', { key: trans(key) });
};

export const msgInvalidFileSize = (size: string) => {
  return trans('shared.invalidFileSize', { key: size });
};
